<mat-form-field class="balance-insurance-picker w-100" subscriptSizing="dynamic">
  <mat-label>{{ labelKey | translate }}</mat-label>
  <mat-select
    [value]="selected"
    [compareWith]="compareById"
    [disabled]="disabled"
    (selectionChange)="onSelectionChange($event.value)"
  >
    @for (insurance of options; track insurance.id) {
      <mat-option [value]="insurance">
        {{ insurance.clinicCarrierName }}
        @if (insurance.memberId) {
          ({{ insurance.memberId }})
        }
      </mat-option>
    }
  </mat-select>
</mat-form-field>
